/**
* 基础菜单 商品关联管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_name" placeholder="请输入商品名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="请输入商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button type="success" size="small" @click="addProductGoods('sale_id')">添加关联商品</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 510px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 80%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" min-width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_name" label="商品名称" min-width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_name" label="销售名称" min-width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_price" label="销售单价" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.sale_price||scope.row.sale_price==0">￥{{scope.row.sale_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="putaway_time" label="上架时间" width="150">
        </el-table-column>
        <el-table-column align="center" label="操作" width="125">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain
                       @click="viewFirm(scope.row.sale_id)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="关联商品" :before-close="prodHandleClose"
               :visible.sync="addProductDialogVisible"
               width="85%"
               center>
      <div class="flexCenter">
        <div class="inline_block">
          <h3 style="float: left">待选列表</h3>
          <div style="float: right;margin-top: 1em">
            <el-input size="small" v-model="selectContent" placeholder="请输入销售名称/商品编码" clearable style="width: 250px;"></el-input>
            <el-button size="small" type="primary" @click="searchSelect">查询</el-button>
          </div>
          <el-table size="small"
                    :data="selectAddProductTableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                    highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="selectDataChange" ref="multipleselectTable"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;height: 452px;overflow: auto">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column
              label="序号"
              width="50">
              <template slot-scope="scope">
                {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="sale_name" label="销售名称" min-width="220" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" width="180" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="sale_price" label="销售单价" width="100" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.sale_price}}</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <div class="block" style="margin-top: 15px">
            <el-pagination
              background
              @size-change="handleLeftSizeChange"
              @current-change="handleLeftCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="selectAddProductTableData.length"
            >
            </el-pagination>
          </div>
        </div>
        <div class="inline_block" style="margin: 20px">
          <div class="mb20">
            <el-button type="primary" icon="el-icon-arrow-left" @click="gotoLeft"
            ></el-button>
          </div>
          <div>
            <el-button type="primary" icon="el-icon-arrow-right" @click="gotoRight"
            ></el-button>
          </div>
        </div>
        <div class="inline_block">
          <h3 style="float: left">已选列表</h3>
          <div style="float: right;margin-top: 1em">
            <el-input size="small" v-model="selectedContent" placeholder="请输入销售名称/商品编码" clearable style="width: 250px;"></el-input>
            <el-button size="small" type="primary" @click="searchSelected">查询</el-button>
          </div>
          <el-table size="small"
                    :data="selectedAddProductTableData.slice((currentPageRight - 1) * pageSizeRight, currentPageRight * pageSizeRight)"
                    highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="selectedDataChange" ref="multipleselectedTable"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;height: 452px;overflow: auto">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column
              label="序号"
              width="50">
              <template slot-scope="scope">
                {{pageSizeRight * (currentPageRight - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="sale_name" label="销售名称" min-width="240" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" width="200" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="sale_price" label="销售单价" width="100" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.sale_price}}</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <div class="block" style="margin-top: 15px">
            <el-pagination
              background
              @size-change="handleRightSizeChange"
              @current-change="handleRightCurrentChange"
              :current-page="currentPageRight"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSizeRight"
              layout="total, sizes, prev, pager, next, jumper"
              :total="selectedAddProductTableData.length"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="prodHandleClose">关 闭</el-button>
            <el-button type="primary" @click="sureAddProduct()">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 查看关联详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="查看关联详情"
               :visible.sync="viewDialogVisible"
               width="80%"
               center>
      <el-form :inline="true" :model="viewformInline" class="user-search">
        <el-form-item label="">
          <el-input size="small" v-model="viewformInline.relation_product_code" placeholder="被关联商品编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="viewformInline.relation_sale_name" placeholder="被关联商品销售名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="searchDetail">查询</el-button>
          <el-button size="small" type="primary" @click="setupSearch" v-if="setupValue">设置商品搜索名称</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <div style="height: 460px;overflow-y: auto">
        <el-table size="small" :data="viewListData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="detailcellDbClick" @selection-change="handleSelectionChange"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <!--          <el-table-column align="center" type="selection" width="60">-->
          <!--          </el-table-column>-->
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{viewpageparm.pageSize * (viewpageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="search_display_name" label="商品搜索名称" min-width="120" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_code" label="关联商品编码" width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="sale_name" label="关联商品销售名称" width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="relation_product_code" label="被关联商品编码" width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="relation_sale_name" label="被关联商品销售名称" width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="creater_name" label="创建人" width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="135">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="viewDialogVisible = false">确 认</el-button>
            <el-button @click="viewDialogVisible = false">取 消</el-button>
      </span>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="viewpageparm" @callFather="detailCallFather"></Pagination>
    </el-dialog>

    <!-- 设置商品搜索名称 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="ruleTitle"
               :visible.sync="setupDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="125px" class="ruleForm">
        <el-form-item label="商品搜索名称" prop="search_display_name" class="displayname">
          <el-input
            type="textarea"
            placeholder="请输入商品搜索名称"
            v-model="selectedSearchDisplayName"
            maxlength="150"
            :autosize="{ minRows: 5, maxRows: 10}"
            show-word-limit
            resize="none"
            auto-complete="off"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSort('ruleForm')">确认</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    relationList, relationSelectedList, relationSelectList,relationAdd,
    relationRelationList, searchDisplayName
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'

  export default {
  name: 'goods',
  data: () => {
    return {
      loading: false, //是显示加载
      addProductDialogVisible: false,//关联商品弹窗
      viewDialogVisible: false, // 查看详情弹窗
      setupDialogVisible: false, // 设置商品搜索名称弹窗
      selectTableData: [],
      ruleTitle: '',
      productId: '',
      formInline: {
        page: 1,
        rows: 10,
        product_code: '',
        product_name: ''
      },
      selectData: {
        // page: 1,
        // rows: 10,
        sale_id: '',
        content: ''
      },
      selectedData: {
        page: 1,
        rows: 10,
        sale_id: '',
        content: ''
      },
      // 查看关联详情
      viewformInline: {
        page: 1,
        rows: 10,
        sale_id: '',
        relation_product_code: '',
        relation_sale_name: '',
      },
      // 设置商品搜索名称
      ruleForm: {
        id: '',
        search_display_name: ''
      },
      // rules表单验证
      rules: {
        // search_display_name: [{required: true, message: '请输入商品搜索名称', trigger: 'blur'}],
      },
      listData: [], //用户数据
      viewListData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      viewpageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页的数据条数
      currentPageRight: 1, // 当前页码
      pageSizeRight: 10, // 每页的数据条数
      selectAddProductTableData: [],
      selectedAddProductTableData: [],
      selectAddProductTableDataList: [],
      selectedAddProductTableDataList: [],
      sale_id: '',
      relation_sale_id: [],
      dialogImageUrl: '',
      dialogVisible: false,
      imgUrl: '',
      product_id: '',
      product_name: '',
      form: {
        image: ''
      },
      isCanSubmit: true,
      isCanLeftButton: true,
      isCanRightButton: true,
      selectContent:'',
      selectedContent:'',
      setupValue: false,
      selectedSearchDisplayName: ''
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    searchSelect() {
      this.selectAddProductTableData = []
      this.selectData.content = this.selectContent
      this.currentPage = 1
      this.loading = true
      relationSelectList(this.selectData)
        .then(res => {
          this.loading = false
          if (res.success) {
            this.selectAddProductTableData = res.content;
          }
        })
        .catch(err => {
        })
    },
    searchSelected() {
      this.selectedAddProductTableData = []
      this.selectedData.content = this.selectedContent
      this.currentPageRight = 1
      this.loading = true
      relationSelectedList(this.selectedData)
        .then(res => {
          this.loading = false
          if (res.success) {
            this.selectedAddProductTableData = res.content;
          }
        })
        .catch(err => {
        })
    },
    addProductGoods(sale_id) {
      if (this.selectTableData.length == 0) {
        this.$message.error('请选择一条数据再操作!');
        return
      }
      if (this.selectTableData.length > 1) {
        this.$message.error('当前操作只能选择一条数据!');
        return
      }
      this.addProductDialogVisible = true;
      this.selectedData.sale_id = this.selectTableData[0].sale_id;
      this.selectData.sale_id = this.selectTableData[0].sale_id;
      this.currentPage = 1;
      this.currentPageRight = 1;
      this.productId = this.selectTableData[0].sale_id;
      relationSelectList(this.selectData)
        .then(res => {
          if (res.success) {
            this.selectAddProductTableData = res.content;
          }
        })
        .catch(err => {
        })
      relationSelectedList(this.selectedData)
        .then(res => {
          if (res.success) {
            this.selectedAddProductTableData = res.content;
          }
        })
        .catch(err => {
        })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      relationList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.content.rows
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.rows
            this.pageparm.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },

    // 查看关联详情弹窗
    viewFirm(sale_id) {
      this.viewDialogVisible = true;
      this.sale_id = sale_id;
      this.viewformInline.sale_id = sale_id;
      this.viewformInline = {
        page: 1,
        rows: 10,
        sale_id: sale_id,
        relation_product_code: '',
        relation_sale_name: '',
      };
      this.getviewdata(this.viewformInline)
    },
    getviewdata(parameter) {
      relationRelationList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.viewListData = res.content.rows
            if (res.content.total == 0) {
              this.setupValue = false
            } else {
              this.setupValue = true
            }
            // 分页赋值
            this.viewpageparm.currentPage = this.viewformInline.page
            this.viewpageparm.pageSize = this.viewformInline.rows
            this.viewpageparm.total = res.content.total
          }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.rows = parm.pageSize
      this.getdata(this.formInline)
    },
    detailCallFather(parm) {
      this.viewformInline.page = parm.currentPage
      this.viewformInline.rows = parm.pageSize
      this.getviewdata(this.viewformInline)
    },
    // 设置商品搜索名称
    setupSearch() {
      this.setupDialogVisible = true;
      this.ruleTitle = '设置商品搜索名称';
      this.selectedSearchDisplayName = this.viewListData[0].search_display_name;
    },
    // 设置商品搜索名称确认
    saveSort() {
      this.ruleForm.sale_id = this.sale_id;
      this.ruleForm.search_display_name = this.selectedSearchDisplayName;
      searchDisplayName(this.ruleForm)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.$message({
              type: 'success',
              message: '您已成功设置商品查询名称'
            });
            this.setupDialogVisible = false;
            this.getviewdata(this.viewformInline)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 设置商品搜索名称取消
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.setupDialogVisible = false;
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata(this.formInline)
    },
    searchDetail() {
      this.viewformInline.page = 1;
      this.getviewdata(this.viewformInline)
    },
    handleRemove(file) {
      console.log(file);
    },
    handleSelectionChange(val) {
      this.selectTableData = val
    },
    selectDataChange(val) {
      this.selectAddProductTableDataList = val;
      // if (val.length == 0) {
      //   this.isCanRightButton = true
      //   return
      // } else {
      //   this.isCanRightButton = false
      //   return
      // }
    },
    selectedDataChange(val) {
      this.selectedAddProductTableDataList = val
      // if (val.length == 0) {
      //   this.isCanLeftButton = true
      //   return
      // } else {
      //   this.isCanLeftButton = false
      //   return
      // }
    },
    prodHandleClose() {
      this.selectData = {
        page: 1,
        rows: 10,
        content: ''
      }
      this.selectContent = ''
      this.selectedContent = ''
      this.addProductDialogVisible = false
    },
    sureAddProduct() {
      let addProducts = [];
      this.selectedAddProductTableData.forEach((item) => {
        addProducts.push(item.sale_id)
      })
      let parameter = {
        sale_id: this.productId,
        relation_sale_id: addProducts
      }
      relationAdd(parameter)
        .then(res => {
          this.isCanSubmit = true;
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.$message({
              type: 'success',
              message: '您已成功添加关联商品!'
            });
            this.prodHandleClose()
            this.getdata(this.formInline)
          }
        })
        .catch(err => {
          this.isCanSubmit = true;
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    gotoLeft() {
      if (this.selectedAddProductTableDataList.length) {
        let idListA = this.selectAddProductTableData.map(i => i.sale_id)
        let target = this.selectAddProductTableData
        let tempB = this.selectedAddProductTableDataList.filter(val=>!idListA.includes(val.sale_id))
        target = target.concat(tempB)
        this.selectAddProductTableData = target;
        let sendTable = this.selectedAddProductTableData;
        this.$refs.multipleselectedTable.selection.forEach((Ele, index) => {
          for (let i = 0; i < sendTable.length; i++) {
            let sale_id = sendTable[i].sale_id;
            if (sale_id == Ele.sale_id) {
              sendTable.splice(i, 1);
            }
          }
        });
        let totalPage = Math.ceil((this.selectedAddProductTableData.length) / this.pageSizeRight)
        this.currentPageRight = totalPage < this.currentPageRight ? totalPage : this.currentPageRight
        this.currentPageRight = this.currentPageRight < 1 ? 1 : this.currentPageRight
      } else {
        this.$message.error('请至少选择一条数据再操作!');
        return
      }
    },
    gotoRight() {
      if (this.selectAddProductTableDataList.length) {
        let idListA = this.selectedAddProductTableData.map(i => i.sale_id)
        let target = this.selectedAddProductTableData
        let tempB = this.selectAddProductTableDataList.filter(val=>!idListA.includes(val.sale_id))
        target = target.concat(tempB)
        this.selectedAddProductTableData = target;
        let sendTable = this.selectAddProductTableData;
        this.$refs.multipleselectTable.selection.forEach((Ele, index) => {
          for (let i = 0; i < sendTable.length; i++) {
            let sale_id = sendTable[i].sale_id;
            if (sale_id == Ele.sale_id) {
              sendTable.splice(i, 1);
            }
          }
        });
        let totalPage = Math.ceil((this.selectAddProductTableData.length) / this.pageSize)
        this.currentPage = totalPage < this.currentPage ? totalPage : this.currentPage
        this.currentPage = this.currentPage < 1 ? 1 : this.currentPage
      } else {
        this.$message.error('请至少选择一条数据再操作!');
        return
      }
    },
    //每页条数改变时触发 选择一页显示多少行
    handleLeftSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleLeftCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    },
    handleRightSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPageRight = 1;
      this.pageSizeRight = val;
    },
    //当前页改变时触发 跳转其他页
    handleRightCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPageRight = val;
    },
    //双击复制
    cellDbClick(row, column, cell, event) {
      if (row.product_name == cell.innerText || row.product_code == cell.innerText) {
        if (event.type === "dblclick") {
          var save = function (e) {
            e.clipboardData.setData('text/plain', cell.innerText);
            e.preventDefault();//阻止默认行为
          }
          document.addEventListener('copy', save);
          document.execCommand("copy");
          document.removeEventListener('copy', save);
        }
        this.$message({message: '复制成功', type: 'success'})
      }
    },
    detailcellDbClick(row, column, cell, event) {
      if (row.relation_product_code == cell.innerText || row.relation_sale_name == cell.innerText) {
        if (event.type === "dblclick") {
          var save = function (e) {
            e.clipboardData.setData('text/plain', cell.innerText);
            e.preventDefault();//阻止默认行为
          }
          document.addEventListener('copy', save);
          document.execCommand("copy");
          document.removeEventListener('copy', save);
        }
        this.$message({message: '复制成功', type: 'success'})
      }
    }
  }
}
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .ruleForm .el-form-item__content {
    line-height: 12px;
  }

  /deep/ .displayname label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

</style>





// WEBPACK FOOTER //
// src/views/goods/GoodAssociation.vue